module.exports = __webpack_public_path__ + "img/02.6a141a3c.jpg";